import { Component } from '@angular/core';

@Component({
  selector: 'app-list-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './list-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class ListIconComponent {}
